import script from "./AlignRightIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AlignRightIcon.vue?vue&type=script&setup=true&lang=js"

export default script